import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { FiMenu, FiBell, FiUser, FiLogOut, FiSettings, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styles from './Header.module.css';

interface HeaderProps {
  onMenuClick: () => void;
  onToggleSidebar: () => void;
  sidebarCollapsed: boolean;
  user: any;
}

export function Header({ onMenuClick, onToggleSidebar, sidebarCollapsed, user }: HeaderProps) {
  const { logout } = useAuth();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setUserMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button 
          className={styles.menuButton}
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <FiMenu size={20} />
        </button>
        
        <button 
          className={styles.sidebarToggle}
          onClick={onToggleSidebar}
          aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {sidebarCollapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
        
        <div className={styles.brand}>
          <h1 className={styles.title}>C-Band</h1>
        </div>
      </div>

      <div className={styles.right}>
        <button className={styles.notificationButton} aria-label="Notifications">
          <FiBell size={20} />
          <span className={styles.notificationBadge}>3</span>
        </button>

        <div className={styles.userMenu}>
          <button 
            className={styles.userButton}
            onClick={() => setUserMenuOpen(!userMenuOpen)}
            aria-label="User menu"
          >
            <div className={styles.userAvatar}>
              {user?.profilePicture ? (
                <img src={user.profilePicture} alt={user.firstName} />
              ) : (
                <FiUser size={16} />
              )}
            </div>
            <span className={styles.userName}>
              {user?.firstName} {user?.lastName}
            </span>
          </button>

          {userMenuOpen && (
            <div className={styles.dropdown}>
              <button className={styles.dropdownItem}>
                <FiUser size={16} />
                Profile
              </button>
              <button className={styles.dropdownItem}>
                <FiSettings size={16} />
                Settings
              </button>
              <hr className={styles.divider} />
              <button 
                className={`${styles.dropdownItem} ${styles.logoutItem}`}
                onClick={handleLogout}
              >
                <FiLogOut size={16} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
